var map = {
	"./_layout": [
		16413,
		6413
	],
	"./_layout.tsx": [
		16413,
		6413
	],
	"./event_call-2603-l": [
		59731,
		9731
	],
	"./event_call-2603-l.tsx": [
		59731,
		9731
	],
	"./event_candy-250324-l": [
		12163,
		2163
	],
	"./event_candy-250324-l.tsx": [
		12163,
		2163
	],
	"./event_draw-2608-l": [
		25655,
		5655
	],
	"./event_draw-2608-l.tsx": [
		25655,
		5655
	],
	"./event_fall-2610-l": [
		59575,
		9575
	],
	"./event_fall-2610-l.tsx": [
		59575,
		9575
	],
	"./event_luckydraw-250626-l": [
		63783,
		3783
	],
	"./event_luckydraw-250626-l.tsx": [
		63783,
		3783
	],
	"./event_npay-2509-l": [
		91684,
		1684
	],
	"./event_npay-2509-l.tsx": [
		91684,
		1684
	],
	"./event_summer-2607-l": [
		99655,
		9655
	],
	"./event_summer-2607-l.tsx": [
		99655,
		9655
	],
	"./main_consulting": [
		47660,
		7660
	],
	"./main_consulting.tsx": [
		47660,
		7660
	],
	"./main_ina": [
		93650,
		3650
	],
	"./main_ina.tsx": [
		93650,
		3650
	],
	"./main_pet": [
		72073,
		2073
	],
	"./main_pet.tsx": [
		72073,
		2073
	],
	"./main_settlement": [
		19101,
		9101
	],
	"./main_settlement.tsx": [
		19101,
		9101
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4301;
module.exports = webpackAsyncContext;